export default "__VITE_ASSET__250c01c1__"